export const paymentNamespace = "payment";
